var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_touch"},[_c('canvas',{ref:"box",attrs:{"id":"canvas"},on:{"mouseup":_vm.touchEnd,"mousedown":_vm.touchStart,"mousemove":_vm.touchMove,"touchstart":_vm.touchStart,"touchmove":_vm.touchMove}})])
}
var staticRenderFns = []

export { render, staticRenderFns }